import { useState, useCallback } from 'react';
import { consultationService } from '../../../services/consultationService';
import type { MedicalConsultation } from '../../../types/api';

export const useConsultationDetail = () => {
  const [consultation, setConsultation] = useState<MedicalConsultation | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchConsultation = useCallback(async (id: number) => {
    setLoading(true);
    setError(null);
    try {
      const data = await consultationService.getById(id);
      setConsultation(data);
    } catch (err) {
      console.error('Error fetching consultation:', err);
      setError('Error al cargar la consulta');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    consultation,
    loading,
    error,
    fetchConsultation,
  };
};
